/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useRef, useEffect, CSSProperties } from "react";
import "./CityAutocomplete.css";
import { useTranslation } from "react-i18next";
import SvgIcon from "../svg-icon/SvgIcon";
import { SelectOptionType } from "../select/Select";
import { Dropdown, Form } from "react-bootstrap";

export interface SelectAutocompleteProps {
  name: string;
  options: SelectOptionType[];
  onChoose?: (option: SelectOptionType) => void;
  defaultText?: string;
  defaultValue?: SelectOptionType | null;
  readOnly?: boolean;
  style?: CSSProperties;
  disabled?: boolean;
  tabIndex?: -1 | 0;
  isWidget?: boolean;
  value?: SelectOptionType
}

const SelectAutocomplete: React.FC<SelectAutocompleteProps> = ({
  name,
  options,
  onChoose,
  defaultText,
  defaultValue,
  readOnly,
  style,
  disabled,
  tabIndex,
  isWidget,
}) => {
  let { t, i18n } = useTranslation();

  let [isOpen, setOpen] = useState(false);
  let [inputValue, setInputValue] = useState(defaultText ? defaultText : "");

  let inputRef = useRef({} as HTMLInputElement);

  useEffect(() => {
    setInputValue(defaultText ? defaultText : "");
  }, [defaultText]);

  useEffect(() => {
    setInputValue(defaultValue ? defaultValue.text : "");
  }, [defaultValue]);

  const optionClickHandler = (option: SelectOptionType) => {
    setInputValue(option?.text);
    setOpen(false);
    if (onChoose) onChoose(option);
  };

  const changeInput = () => {
    if (onChoose) onChoose({ value: 0, text: inputRef.current.value });
    setInputValue(inputRef.current.value);
    setOpen(true);
    if (inputRef.current.value.length === 0) {
      setOpen(false);
    }
  };

  const missClickHandler = () => {
    if (isOpen) {
      setOpen(false);
    }
  };

  const SelectContent = (
    <div className="select-content" style={{ zIndex: 20, maxHeight: "186px" }}>
      {options?.map((option, index) => {
        return (
          <div
            className="select-content-item"
            key={index}
            onClick={() => optionClickHandler(option)}
          >
            {option?.text}
          </div>
        );
      })}
      {!options?.length && inputRef?.current?.value?.length > 0 ? (
        <div className="select-content-item">
          {t("custom_property.no_select_found", { name })}
        </div>
      ) : null}
    </div>
  );

  const inputSelectProps = {
    type: "text",
    ref: inputRef,
    value: inputValue,
    onChange: changeInput,
    readOnly: readOnly,
    disabled: disabled,
    tabIndex: tabIndex,
  };

  return isWidget ? (
    <Dropdown className={"input-search" + (disabled ? " disabled" : "")}>
      <div className={"select " + (isOpen ? "active" : "")}>
        {isOpen ? (
          <div className="miss-click-handler" onClick={missClickHandler} />
        ) : (
          ""
        )}
        <SvgIcon className="icon icon-search" href="#svg_icon_search" />
        <Form.Control style={{ fontSize: "16px" }} {...inputSelectProps} />
        {SelectContent}
      </div>
    </Dropdown>
  ) : (
    <div className={"input-search" + (disabled ? " disabled" : "")}>
      <div className={"select " + (isOpen ? "active" : "")}>
        {isOpen ? (
          <div className="miss-click-handler" onClick={missClickHandler} />
        ) : (
          ""
        )}
        <SvgIcon className="icon icon-search" href="#svg_icon_search" />
        <input
          className="input"
          style={{ fontSize: "16px" }}
          {...inputSelectProps}
        />
        {SelectContent}
      </div>
    </div>
  );
};

export default SelectAutocomplete;
